import {
  getCookie,
  getBundleBuilderState,
  setBundleBuilderState,
  getInitialBundleState,
} from "../../pages/bundleBuilder.js";

// typ produktu 2. kroku (Podložky)
const STEP_TWO_TYPE_ID = getInitialBundleState().steps[2].productId;

function createBundle() {
  const headers = new Headers();
  headers.append("X-CSRF-TOKEN", getCookie("csrfToken"));
  headers.append("Accept", "application/json, text/javascript");
  headers.append("x-requested-with", "XMLHttpRequest");

  return fetch("/vytvorit-set", { method: "POST", headers })
    .then((res) => res.json())
    .then((body) => body.bundleId);
}

function redirectToStep2(bundleId, floorId) {
  // /upravit-set/{bundleId}/{typeId kroku 2}/{id vybranej podlahy}
  window.location.href = `/upravit-set/${bundleId}/${STEP_TWO_TYPE_ID}/${floorId}`;
}

// pridá podlahu ako krok 1 a presmeruje do konfigurátora na krok 2
function addFloor(product, mode) {
  const state = mode === "new" ? null : getBundleBuilderState();

  if (!state) {
    createBundle().then((bundleId) => {
      const fresh = getInitialBundleState();
      fresh.bundleId = bundleId;
      fresh.steps[1].product = product;
      fresh.currentStep = 2;
      setBundleBuilderState(fresh);
      redirectToStep2(bundleId, product.id);
    });

    return;
  }

  const go = (bundleId) => {
    state.bundleId = bundleId;
    state.steps[1].product = product;

    if (!state.currentStep || state.currentStep < 2) {
      state.currentStep = 2;
    }

    setBundleBuilderState(state);
    redirectToStep2(bundleId, product.id);
  };

  if (state.bundleId) {
    go(state.bundleId);
  } else {
    createBundle().then(go);
  }
}

// má rozrobený set už produkt (t.j. nezakladáme nový)?
function hasAnyProduct(state) {
  return !!(
    state &&
    state.steps &&
    Object.keys(state.steps).some((key) => state.steps[key].product)
  );
}

function showModal() {
  if (window.jQuery) {
    window.jQuery("#bundle-conflict-modal").modal("show");

    return true;
  }

  return false;
}

function hideModal() {
  if (window.jQuery) {
    window.jQuery("#bundle-conflict-modal").modal("hide");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const buttons = document.querySelectorAll(".js-add-floor-to-set");

  if (!buttons.length) {
    return;
  }

  let pendingProduct = null;

  buttons.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();

      let product;

      try {
        product = JSON.parse(btn.getAttribute("data-set-product"));
      } catch (err) {
        return;
      }

      const qtyInput = document.getElementById(`product-${product.id}-quantity`);
      product.quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      // nový set (bez produktov) + v košíku už set je → upozornenie
      const startingNewSet = !hasAnyProduct(getBundleBuilderState());
      const cartHasBundle = btn.dataset.cartHasBundle === "1";

      if (startingNewSet && cartHasBundle) {
        pendingProduct = product;

        if (showModal()) {
          return;
        }
      }

      addFloor(product, "existing");
    });
  });

  const confirmBtn = document.querySelector(".js-bundle-replace-confirm");

  if (confirmBtn) {
    confirmBtn.addEventListener("click", () => {
      hideModal();

      if (pendingProduct) {
        addFloor(pendingProduct, "existing");
      }
    });
  }
});
